// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1nmt1","legacyBtn":"MutateMid_legacyBtn__399GE"};